import { createClient } from '@/services/clients/createClient'

const { VUE_APP_EPOPS_URL } = process.env
const options = {
  baseURL: VUE_APP_EPOPS_URL,
}
export const epopsClient = createClient(options)
